import type { MappedReferencesContext } from '../../../../contexts/ReferencesContext';
import type { DevisPrestationsRenderModel } from '../utils/build-devis-prestations-render-model.util';

import { DevisPrestationsServiceUsagesTable } from './DevisPrestationsServiceUsagesTable';
import { DevisPrestationsServiceUsagesText } from './DevisPrestationsServiceUsagesText';

export type DevisPrestationsLayout = 'text' | 'table';

interface Props {
  readonly currenciesIdMap: MappedReferencesContext['currenciesIdMap'];
  readonly layout: DevisPrestationsLayout;
  readonly renderModel: DevisPrestationsRenderModel;
  readonly unitsIdMap: MappedReferencesContext['unitsIdMap'];
  readonly vatsIdMap: MappedReferencesContext['vatsIdMap'];
}

export const DevisPrestationsServiceUsages = ({
  currenciesIdMap,
  layout,
  renderModel,
  unitsIdMap,
  vatsIdMap,
}: Readonly<Props>) =>
  layout === 'table' ? (
    <DevisPrestationsServiceUsagesTable
      currenciesIdMap={currenciesIdMap}
      groups={renderModel.groups}
      unitsIdMap={unitsIdMap}
      vatsIdMap={vatsIdMap}
    />
  ) : (
    <DevisPrestationsServiceUsagesText
      currenciesIdMap={currenciesIdMap}
      groups={renderModel.groups}
      unitsIdMap={unitsIdMap}
      vatsIdMap={vatsIdMap}
    />
  );
